export const tl = (n) =>
  (n || 0).toLocaleString("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 0,
  });

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("tr-TR") : "");

export const clone = (obj) => {
  if (typeof structuredClone === "function") return structuredClone(obj);
  return JSON.parse(JSON.stringify(obj));
};
